import React from 'react';
import ActionButton from '../../common/ActionButton';
import { ROOT_URL_V2 } from '../../../config';

type TDownloadCSVButtonProps = {
    endpoint: string;
    params?: URLSearchParams | Record<string, string>;
}

export default function DownloadCSVButton({
    endpoint,
    params: providedParams
}: TDownloadCSVButtonProps) {
    const baseUrl = `${ROOT_URL_V2}${endpoint}`;

    // Use provided params or create empty params
    const params = providedParams ? new URLSearchParams(providedParams) : new URLSearchParams();
    params.set('format', 'csv');

    // Construct the download URL
    const downloadUrl = `${baseUrl}/?${params.toString()}`;

    return (
        <ActionButton
            iconClass="icon-navigation-next-4"
            tooltip="Export as CSV"
            onAction={() => {
                window.location.href = downloadUrl;
            }}
        />
    );
};
